export default "__VITE_ASSET__4e59ae37__"